import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@gift/ui/components/grid/Grid';
import { Cell } from '@gift/ui/components/grid/Cell';
import { FontFamilyDropdown } from './font-family/FontFamilyDropdown';
import { Bold } from './styling-options/Bold';
import { Italic } from './styling-options/Italic';
import styles from './TextStylingMenu.module.scss';

export const _TextStylingMenu = ({ variableIds, options }: Props) => (
    <div className={styles.container}>
        <Grid gap='s' wrap className={styles.grid}>
            {options.includes('font-family') && (
                <Cell fill>
                    <FontFamilyDropdown variableIds={variableIds} />
                </Cell>
            )}

            <Cell fit>
                <Grid gap='s' wrap>
                    {options.includes('bold') && (
                        <Cell fit>
                            <Bold variableIds={variableIds} />
                        </Cell>
                    )}

                    {options.includes('italic') && (
                        <Cell fit>
                            <Italic variableIds={variableIds} />
                        </Cell>
                    )}
                </Grid>
            </Cell>
        </Grid>
    </div>
);

type Props = {
    variableIds: string[],
    options: string[]
};

const allOptions = ['font-family', 'bold', 'italic']; // underline unsupported in ff-canvas

const mapStateToProps = () => ({
    options: allOptions
});

export const TextStylingMenu = connect(
    mapStateToProps
)(_TextStylingMenu);
